var render = function () {
var _obj;
var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',_vm._g({class:{'ui-select': true, 'ui-select--open': _vm.open || _vm.opened },attrs:{"tabindex":"1"},on:{"blur":function($event){_vm.open = false}}},( _obj = {}, _obj[this.$panorama.utils.isMobile ? 'touchstart' : 'click'] = _vm.toggle, _obj )),[(!_vm.opened && _vm.items.length > 0)?_c('div',{staticClass:"ui-select__tag"},[_c('span',[_vm._v(" "+_vm._s(_vm.currentItem)+" ")]),_c('panorama-accordion-icon',{attrs:{"top":_vm.open,"bottom":!_vm.open}})],1):_vm._e(),_c('ul',{class:{
      'ui-select__tags': true,
      'ui-select__tags--open': _vm.open || _vm.opened,
      'ui-select__tags--reverse': _vm.reverse
    }},_vm._l((_vm.items),function(item,index){return _c('li',{key:index,class:{
        'ui-select__item': true,
        'ui-select__item--opened': _vm.opened,
        'ui-select__item--active': +index === _vm.activeIndex
      },on:{"click":function($event){return _vm.select(+index)}}},[_vm._v(" "+_vm._s(item)+" ")])}),0)])}
var staticRenderFns = []

export { render, staticRenderFns }